export default "__VITE_ASSET__58b4a647__"